import React from 'react'
import tw, { styled } from 'twin.macro'
import Img from 'gatsby-image'
import HexagonCheck from '../../images/Hexagon-Check.svg'
import { LargeSolidTealButton } from '../../utils/styles'
import LocalizedLink from '../localized-link'
import i18n from '../../../config/i18n'
const PredictYourSalesWrapper = styled.div`
  .benefits-icon {
    width: 50px;
    height: 50px;
  }
  .top-icon {
    position: absolute;
    top: -45px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
  }
`

const PredictYourSales = ({ predict, items, button, id, i18n }) => {
  return (
    <PredictYourSalesWrapper
      tw="container pt-20 pb-8 text-center md:pt-28 md:pb-14"
      id={id}
      className="industry-benefit">
      <div tw="bg-air pt-16 relative rounded-lg px-4">
        <div className="top-icon">
          <Img fluid={predict.top_icon.fluid} tw="w-32"></Img>
        </div>
        <h2 tw="text-navy">{predict.headline.text}</h2>
        <p tw="text-ocean text-xl max-w-xl md:m-auto pt-4 pb-4 md:pb-0">
          {predict.subheadline.text}
        </p>
        <div tw="max-w-4xl m-auto pt-10">
          <Img fluid={predict.image.fluid}></Img>
        </div>
      </div>
      <div tw="grid md:grid-cols-3 gap-4 text-center md:text-left mt-8 md:mt-14 items-start justify-items-center">
        {items.map((item, key) => {
          return (
            <div key={key} tw="flex flex-col gap-4 w-72">
              <img
                tw="m-auto md:ml-0"
                src={HexagonCheck}
                className="benefits-icon"></img>
              <h4 tw="my-1 text-navy">{item.benefits_headline}</h4>
              <p tw="m-auto md:m-0 text-ocean">{item.benefits_description}</p>
            </div>
          )
        })}
      </div>
      {typeof button != 'undefined' ? (
        <LocalizedLink to="/request-meeting">
          <LargeSolidTealButton tw="mt-10 md:max-w-sm md:m-auto md:mt-16">
            {i18n.buttons.learn_more}
          </LargeSolidTealButton>
        </LocalizedLink>
      ) : (
        false
      )}
    </PredictYourSalesWrapper>
  )
}
export default PredictYourSales
